import { Action } from '@ngrx/store';
import { IUploadItem } from '@stylehaven/components';

export enum UploadItemActionTypes {
    Add = '[Uploads] Add',
    Remove = '[Uploads] Remove',
    Update = '[Uploads] Update',
    AddOrUpdate = '[Uploads] Add or Update',
    Clear = '[Uploads] Clear'
}

export class AddOrUpdateUploadItem implements Action {
    readonly type: UploadItemActionTypes.AddOrUpdate = UploadItemActionTypes.AddOrUpdate;
    constructor(public uploadItem: IUploadItem) {}
}

export class AddUploadItem implements Action {
    readonly type: UploadItemActionTypes.Add = UploadItemActionTypes.Add;
    constructor(public uploadItem: IUploadItem) {}
}

export class UpdateUploadItem implements Action {
    readonly type: UploadItemActionTypes.Update = UploadItemActionTypes.Update;
    constructor(
        public id: string,
        public changes: Partial<IUploadItem>
    ) {}
}

export class RemoveUploadItem implements Action {
    readonly type: UploadItemActionTypes.Remove = UploadItemActionTypes.Remove;
    constructor(public id: string) {}
}

export class ClearUploadItems implements Action {
    readonly type: UploadItemActionTypes.Clear = UploadItemActionTypes.Clear;
}

export type UploadItemAction =
    | AddUploadItem
    | UpdateUploadItem
    | RemoveUploadItem
    | AddOrUpdateUploadItem
    | ClearUploadItems;
